import { ViewModel,View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { distinct } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";

export class DetailValueSelectorViewModel extends SelectorBaseViewModel<detailValue> implements IDetailValueLoadingObserver{
    
    constructor(parentViewModel: ViewModel,detailId:string,valueLoader:ValueLoader) {
        super(parentViewModel,true);
        this.detailId = detailId;
        this.loader = valueLoader;
        this.loader.attach(this);
        this.refresh();
    }
    
    private loader : ValueLoader;
    public detailId:string;
    protected override async loadData(): Promise<detailValue[]> {
        let result2 = this.loader.getdetails(this);
        return result2;
    }

    update(values: detailValue[]) {
        this.updateItems(values);
    }
    public override requestRefresh(): void {
        this.loader.refresh(this);   
    }
}

export class detailValue extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}

interface IDetailValueLoadingObserver{
    update(values:detailValue[]);
    detailId:string;

}

export class ValueLoader{
    private lastResult: Map<string,any>;
    constructor() {
        this.observers = [];       
        this.lastResult = new Map<string,any>(); 
        this.requests = []; 
    }
    private requests:{requester:IDetailValueLoadingObserver,key:string,resolve: (value: detailValue[] | PromiseLike<detailValue[]>) => void, reject: (reason?: any) => void}[];
    public async getdetails(requester:IDetailValueLoadingObserver):Promise<detailValue[]>{

        if(this.lastResult.has(requester.detailId)){
            return new ValueParser().Parse(this.lastResult.get(requester.detailId),<ViewModel><unknown>requester)
        }
        let a = new Promise<detailValue[]>((success,reject)=>{
            this.requests.push({
                requester:requester,
                key:requester.detailId,
                resolve:success,
                reject:reject
            });
            this.tryRun();
        });
        return a;
    }

    private timer:any;
    private tryRun(){
        clearTimeout(this.timer);
        this.timer = setTimeout(async () => {
            let allRequests = [...this.requests];
            this.requests.splice(0,this.requests.length);
            let keys = distinct(allRequests.map(q=>q.key));
            let notifiedOnes = new Map<string,IDetailValueLoadingObserver[]>();
            try{
                let result = await ServerConnection.callServer('Complex/AccountingServices/GetDistinguishingDetailValues',{
                    DetailIds:keys
                });
                if(result.IsSuccessful==false){
                    allRequests.forEach(q=>q.reject("Failed"));
                }
                result.Details.forEach(d => {
                    this.lastResult.set(d.Id,d.Values);
                    allRequests.forEach(q=>{
                        if(q.key==d.Id){
                            if(notifiedOnes.has(q.key)==false){
                                notifiedOnes.set(q.key,[]);
                            }
                            let current = notifiedOnes.get(q.key);
                            if(current.includes(q.requester)==false)
                                current.push(q.requester);
                            notifiedOnes.set(q.key,current);
                            q.resolve(new ValueParser().Parse(this.lastResult.get(q.key),<ViewModel><unknown>q.requester)) 
                        }
                    })
                });
                keys.forEach(q=>{
                    this.notify(notifiedOnes.get(q),q,this.lastResult.get(q));
                })
            }
            catch(ex){
                allRequests.forEach(q=>q.reject(ex));
            }            
        }, 200);
    }
    public async refresh(requester:IDetailValueLoadingObserver){
        this.lastResult.delete(requester.detailId);
        let result = await this.getdetails(requester);
        requester.update(result);
    }
    
    private observers:WeakRef<IDetailValueLoadingObserver>[];

    attach(observer:IDetailValueLoadingObserver){
        let wr = new WeakRef<IDetailValueLoadingObserver>(observer);
        this.observers.push(wr);
    }
    detach(observer:IDetailValueLoadingObserver){
        let index = this.observers.findIndex(x=>x.deref()==observer);
        if(index>-1){
            this.observers.splice(index)
        }
    }
    notify(except:IDetailValueLoadingObserver[],detailId:string,dtoResult:any){
        for(let i=this.observers.length-1;i>=0;i--){
            let x = this.observers[i].deref();
            if(x==null){
                this.observers.splice(i,1);
            }else{
                if(x.detailId==detailId && except.includes(x)==false){
                    let parsedResult = new ValueParser().Parse(dtoResult,<ViewModel><unknown>x);
                    x.update(parsedResult);
                }
            }
        }
    }
}

class ValueParser{
    public Parse(dto:any,parent:ViewModel):detailValue[]{
        return dto.map(q=>{
            let r = new detailValue(parent);
            r.id = q.Id
            r.name = q.Value;
            r.code = q.Code;
            r.title = `${r.name} (${r.code})`;
            return r;
        })
    }
}